module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71016/img/content-remix-post-publish/content-remix-ja.png"